export default "__VITE_ASSET__BKpITdxI__"